import { websockets } from '../../engine/websockets-sidecar'
import { common } from '../../main/common-sidecar'
import { uiFps } from '../../ui/uiFps-sidecar'
import { buttons2 } from '../../uiParts/buttons2-sidecar'
import { clickEater } from '../../uiParts/clickEater-sidecar'
import { stevieTexts2 } from '../../uiParts/stevieTexts2-sidecar'
import { voyageBackground } from './voyageBackground-sidecar'
import { voyageBodies } from './voyageBodies-sidecar'
import { voyageBullets } from './voyageBullets-sidecar'
import { voyageCamera } from './voyageCamera-sidecar'
import { voyageCarryable } from './voyageCarryable-sidecar'
import { voyageCrew } from './voyageCrew-sidecar'
import { voyageFloatingText } from './voyageFloatingText-sidecar'
import { voyageGameManager } from './voyageGameManager-sidecar'
import { voyageGameStatus } from './voyageGameStatus-sidecar'
import { voyageIndicators } from './voyageIndicators-sidecar'
import { voyageJettisons } from './voyageJettisons-sidecar'
import { voyageMenuMain } from './voyageMenuMain-sidecar'
import { voyageMovementIndicators } from './voyageMovementIndicators-sidecar'
import { voyageMultiplayerCursors } from './voyageMultiplayerCursors-sidecar'
import { voyageParticles } from './voyageParticles-sidecar'
import { voyagePicker } from './voyagePicker-sidecar'
import { voyageProgressBars } from './voyageProgressBars-sidecar'
import { voyageSaver } from './voyageSaver-sidecar'
import { voyageSplatters } from './voyageSplatters-sidecar'
import { voyageTilemapEditor } from './voyageTilemapEditor-sidecar'
import { voyageToolBodyAlign } from './voyageToolBodyAlign-sidecar'
import { voyageUiBuyStuff } from './voyageUiBuyStuff-sidecar'
import { voyageUiEditor } from './voyageUiEditor-sidecar'
import { voyageUiGame } from './voyageUiGame-sidecar'
import { voyageUiGameMultiplayer } from './voyageUiGameMultiplayer-sidecar'
import { voyageUiInfoBar } from './voyageUiInfoBar-sidecar'
import { voyageUiLoadShip } from './voyageUiLoadShip-sidecar'
import { voyageUiMessage } from './voyageUiMessage-sidecar'
import { voyageUiMultiListGames } from './voyageUiMultiListGames-sidecar'
import { voyageUiNav } from './voyageUiNav-sidecar'
import { voyageUiPaused } from './voyageUiPaused-sidecar'
import { voyageUiTutorial } from './voyageUiTutorial-sidecar'
import { voyageWebsockets } from './voyageWebsockets-sidecar'

export const update = (time: number, delta: number) => {
  // let ctx = goatScene.getContext()
  common.setUpdateDelta(delta / 1000)
  let curSpeedScale = 1

  if (voyageGameManager.get().isPaused) {
    curSpeedScale = 0
  }

  if (voyageGameStatus.get().isGameEnded) {
    curSpeedScale = 0
  }

  common.setUpdateDeltaScaled((delta / 1000) * curSpeedScale)

  voyageBackground.update()
  voyageGameStatus.update()
  voyageGameManager.update()

  uiFps.update(voyageCamera.getGameBounds())

  buttons2.updateAll()

  voyageUiMessage.update()
  voyageUiMultiListGames.update()
  voyageMenuMain.update()

  voyageCrew.updateAll()
  voyageBodies.updateAll()
  voyageIndicators.updateAll()

  voyagePicker.update()
  voyageTilemapEditor.update()
  voyageToolBodyAlign.update()
  voyageCamera.update()

  voyageBullets.updateAll()
  voyageCarryable.updateAll()
  voyageJettisons.updateAll()

  voyageMultiplayerCursors.updateAll()
  voyageMovementIndicators.updateAll()

  voyageUiInfoBar.update()
  voyageUiTutorial.update()
  voyageParticles.updateAll()
  voyageFloatingText.updateAll()
  voyageUiPaused.update()

  voyageUiBuyStuff.update()
  voyageUiNav.update()
  voyageUiLoadShip.update()
  voyageUiEditor.update()

  voyageUiGame.update()
  voyageUiGameMultiplayer.update()
  voyageProgressBars.updateAll()

  voyageSplatters.updateAll()

  stevieTexts2.updateAll()
  clickEater.updateAll()

  voyageSaver.trySave()
  websockets.update()
}
